import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';
import { InterceptorService } from 'ng2-interceptors';
import 'rxjs/add/operator/toPromise';
import { environment } from '../../../environments/environment';
import {ThirdParty} from '../../entity/third-party';


@Injectable()
export class ProducersAutocompleteService {

    private headers = new Headers({'Content-Type': 'application/json'});

    constructor(private http: InterceptorService) { }

    searchProducers(producerSearch, parentId) {
        const params = {
            'search': producerSearch,
            'parentId': parentId
        };
        return this.http.post(environment.apiUrl + 'site-api/list/producers', JSON.stringify(params), {headers: this.headers})
            .map(function(response) {
                const producers = [];
                const responseObj = response.json();
                for (const index in responseObj){
                    const producer = new ThirdParty();
                    producer.fromJSON(responseObj[index]);
                    producers[producers.length] = producer;
                }
                return producers;
            })
            .catch(this.handleError);
    }


    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/producers/producers-autocomplete.service.ts